import styles from './orderGrid.module.css';
import { FunctionComponent, PropsWithChildren } from 'react';

export const OrderGrid: FunctionComponent<PropsWithChildren> = ({ children }) => {
    return <div className={styles.orderGrid}>{children}</div>;
};
